import { cn } from '../lib/utils'

import Skeleton from './Skeleton'

/** Exact-layout placeholder for `ActiveOrderCard` (RP-5936 prototype
 * geometry): the 90×108 image tile plus the card padding fix the height, so
 * the swap causes no layout shift. */
export function ActiveOrderCardSkeleton() {
  return (
    <div
      className="flex w-full items-center rounded-lg border border-border bg-surface p-16"
      data-testid="active-order-card-skeleton"
    >
      <div className="flex min-w-0 flex-1 items-center gap-20">
        <Skeleton r={4} className="h-108 w-90 shrink-0" />
        <div className="flex min-w-0 flex-1 flex-col gap-8 pr-20">
          <Skeleton h={16} className="w-[52%]" />
          <Skeleton h={12} className="w-[34%]" />
        </div>
      </div>
    </div>
  )
}

/**
 * Exact-layout placeholder for the Active Orders section: the heading bar
 * (132×20 in the 28px line box) plus two order cards.
 *
 * Defined once and rendered both by the section itself while its trait is
 * pending and by the Hub's boot screen, which paints the tab's placeholders
 * before the section can mount.
 */
export default function ActiveOrdersSkeleton({
  isReserved,
}: {
  /** Reserve the layout without painting it (the anti-flash window). */
  isReserved?: boolean
}) {
  return (
    <section
      className={cn(
        'flex flex-col gap-16 max-lg:px-16',
        isReserved && 'invisible',
      )}
      aria-busy="true"
      data-testid="active-orders"
    >
      {/* Prototype: the heading renders as a bar while loading, the real text
          once settled. */}
      <Skeleton w={132} h={20} className="my-4" />
      <div
        className="flex flex-col gap-16"
        data-testid="active-orders-skeleton"
      >
        <ActiveOrderCardSkeleton />
        <ActiveOrderCardSkeleton />
      </div>
    </section>
  )
}
